import { colors } from '@insurancemenu/imenu-components-lib';
import { createUseStyles } from 'react-jss';

const styles = {
  modalContent: {
    textAlign: 'left',
    marginTop: '3rem',
  },
  sendGridContext: {
    '& pre': {
      borderRadius: '1rem',
      background: '#222933',
    },
  },
  contextTitle: {
    paddingBottom: '1rem',
    fontSize: '1.8rem',
    fontWeight: 400,
    borderBottom: '1px solid grey',
    color: colors.neutral[700],
    margin: '4rem 0 1rem',
  },
  infoTableWrapper: {
    border: `0.1rem solid ${colors.neutral[300]}`,
    borderRadius: '1rem',
    marginTop: '2rem',
    marginBottom: '2rem',
    overflow: 'hidden',
  },
  tableRow: {
    borderBottom: `1px solid ${colors.neutral[300]}`,
    '&:last-of-type': {
      borderBottom: 'none',
    },
  },
  tableCell: {
    font: { size: '1.6rem', lineHeight: '2.4rem' },
    color: colors.neutral[900],
    letterSpacing: '0.02rem',
    padding: '1.6rem 1rem',
    '&:first-child': {
      backgroundColor: colors.neutral[100],
      width: '3rem',
      paddingLeft: '2.4rem',
      fontWeight: 700,
      textTransform: 'uppercase',
      fontSize: '1.4rem',
    },
    '&:last-child': {
      paddingRight: '2.4rem',
    },
  },
  tableBody: {
    boxSizing: 'border-box',
  },
};

const createStyles = createUseStyles(styles);
export { createStyles };
